export const FRONTEND_BASE_URL = 'https://grindon.fitness';

export const legalLinks = {
    privacy: `${FRONTEND_BASE_URL}/privacy`,
    terms: `${FRONTEND_BASE_URL}/terms`,
    eula: `${FRONTEND_BASE_URL}/eula`,
    communityGuidelines: `${FRONTEND_BASE_URL}/community-guidelines`,
    support: `${FRONTEND_BASE_URL}/support`,
};
